module.exports = __webpack_public_path__ + "InfiniteRunner-646f6e640d58c31e53f8446816cd77dd.png";